module.exports = __webpack_public_path__ + "static/media/alex.199177cb.csv";